import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterProps } from "../../utils/router";

import { get as getResponse } from "../../actions/surveys";
import { pending } from "../../actions/general";
import { tokenize } from "../../actions/auth";
import Template from "../../layout/template";
import Layout from "../../layout";

export class SurveyComponent extends React.Component {
    constructor() {
        super();
        
        this.state = {

        };
        console.log('Survey constructor called!');
    }

    componentDidMount = async () => {
        await this.props.pending(true);

        const params = new URLSearchParams(window.location.search);
        const token = params.get("t");
        const instance = params.get("i");

        if (!!token) {
            await this.props.tokenize(instance, token);
            window.location.href = window.location.origin + window.location.pathname;
        }
        this.fetchData();
    }

    get title() {
        return this.props.page?.title?.trim().length ? this.props.page?.title : this.state.page.title;
    }

    get id() {
        return this.props?.params?.id;
    }

    fetchData = async () => {
        setTimeout(async () => {
            await this.props.pending(true);
            const response = await this.props.getResponse(this.id);
            response.json_name = response.Template.key;
            delete response.Template.key;
            this.setState({
                ...response
            });
            await this.props.pending(false);
        }, 30);
    }


    render() {
        return (
            <>
                <Layout>
                    <Template {...this.state?.Template} richTextLabels private={ this.state?.private } data={ this.state.meta?.save?.data } key={this.state?.Template?.key} autosave={ this.state.autosave } logo={this.state?.logos?.normal} invite={ this.id } />
                </Layout>
            </>
        )
    }
}

SurveyComponent.propTypes = {
    general: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        general: state.general,
    });
};



export default connect(mapStateToProps, { pending, tokenize, getResponse })(withRouterProps(SurveyComponent));
